/**
 * SHEIN query-brand-list / query-ip-list 响应解析
 */

function normalizeBrandPayload(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  return [];
}

function normalizeIpPayload(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.list)) return raw.list;
  return [];
}

export function flattenBrandRows(raw) {
  return normalizeBrandPayload(raw).map((item, index) => ({
    key: item?.brand_code || `brand-${index}`,
    brandCode: item?.brand_code || '—',
    brandName: item?.brand_name || '—',
  }));
}

export function flattenIpRows(raw) {
  return normalizeIpPayload(raw).map((item, index) => ({
    key: String(item?.id ?? item?.ipId ?? index),
    ipId: item?.ipId != null ? String(item.ipId) : '—',
    ipName: item?.ipName || '—',
    ipNameCn: item?.ipNameCn || '—',
    ipGroupId: item?.ipGroupId != null ? String(item.ipGroupId) : '—',
    ipGroupName: item?.ipGroupName || '—',
  }));
}

export function countBrandRows(raw) {
  return flattenBrandRows(raw).length;
}

export function countIpRows(raw) {
  return flattenIpRows(raw).length;
}
